import {Suspense} from 'react';
import {Outlet} from 'react-router';
import '@/styles/global.css';
import {JotaiProvider} from '@/store/provider';
import {Layout} from '@/components/layout';
import {AppInitializer} from '@/components/app-initializer';
import {ErrorBoundary} from '@/components/ui/error-boundary';
import {WebVitals} from '@/components/web-vitals';
import {LoadingSpinner} from '@/components/ui/loading-spinner';

function PageFallback() {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '200px',
            }}
        >
            <LoadingSpinner />
        </div>
    );
}

export default function AppLayout() {
    return (
        <JotaiProvider>
            <WebVitals />
            <ErrorBoundary action="App">
                <AppInitializer />
                <Layout>
                    <Suspense fallback={<PageFallback />}>
                        <Outlet />
                    </Suspense>
                </Layout>
            </ErrorBoundary>
        </JotaiProvider>
    );
}
